import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { translations } from '@/translations/translations';

interface Props {
  copy: typeof translations.fr.admin.excelFiles.themes.questions;
  count: number;
  open: boolean;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function ThemeQuestionDeactivateConfirmation({ copy, count, open, isPending, onOpenChange, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl border-border/60 bg-background shadow-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>{copy.deactivateConfirmTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {copy.deactivateConfirmDescription.replace('{count}', String(count))}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>{copy.cancelSelection}</AlertDialogCancel>
          <AlertDialogAction disabled={isPending} onClick={(event) => { event.preventDefault(); onConfirm(); }}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            {copy.confirmDeactivate}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
